import { createReducer } from '@reduxjs/toolkit';

import { STATUS } from '@constants/status';

import {
  REGISTRATIONS_INFO_RESET,
  REGISTRATIONS_INFO_FETCH_START,
  REGISTRATIONS_INFO_FETCH_SUCCESS,
  REGISTRATIONS_INFO_FETCH_FAILURE,
  REGISTRATIONS_INFO_CREATE_START,
  REGISTRATIONS_INFO_CREATE_SUCCESS,
  REGISTRATIONS_INFO_CREATE_FAILURE,
  REGISTRATIONS_INFO_UPDATE_START,
  REGISTRATIONS_INFO_UPDATE_SUCCESS,
  REGISTRATIONS_INFO_DELETE_START,
  REGISTRATIONS_INFO_DELETE_SUCCESS,
  REGISTRATIONS_INFO_DELETE_FAILURE,
} from './registrationsInfo.const';

export const initialState = {
  model: {},
  meta: {
    status: STATUS.LOADING,
  },
};

const registrationsInfoReducer = createReducer(initialState, builder => {
  builder
    .addCase(REGISTRATIONS_INFO_RESET, () => initialState)
    .addCase(REGISTRATIONS_INFO_FETCH_START, state => {
      state.meta.status = STATUS.LOADING;
      state.meta.errorMessage = '';
    })
    .addCase(REGISTRATIONS_INFO_FETCH_SUCCESS, (state, { payload = {} }) => {
      state.model = payload.data;
      state.meta.status = STATUS.SUCCESS;
    })
    .addCase(REGISTRATIONS_INFO_FETCH_FAILURE, (state, { payload = {} }) => {
      state.model = {};
      state.meta.status = STATUS.ERROR;
      state.meta.errorMessage = payload.errorMessage;
    })
    .addCase(REGISTRATIONS_INFO_CREATE_START, () => {})
    .addCase(REGISTRATIONS_INFO_CREATE_SUCCESS, (state, { payload = {} }) => {
      state.model = payload.data;
    })
    .addCase(REGISTRATIONS_INFO_CREATE_FAILURE, () => {})
    .addCase(REGISTRATIONS_INFO_UPDATE_START, () => {})
    .addCase(REGISTRATIONS_INFO_UPDATE_SUCCESS, state => {
      state.meta.status = STATUS.SUCCESS; // TODO: VFE-672 Restore once API response has been corrected
    })
    .addCase(REGISTRATIONS_INFO_DELETE_START, state => {
      state.meta.status = STATUS.UPDATING;
    })
    .addCase(REGISTRATIONS_INFO_DELETE_SUCCESS, state => {
      state.model = {};
      state.meta.status = STATUS.SUCCESS;
    })
    .addCase(REGISTRATIONS_INFO_DELETE_FAILURE, state => {
      state.meta.status = STATUS.SUCCESS;
    })
    .addDefaultCase(() => {});
});

export default registrationsInfoReducer;
